import { render, staticRenderFns } from "./Pers.vue?vue&type=template&id=ea4c7b26"
import script from "./Pers.vue?vue&type=script&lang=js"
export * from "./Pers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports